import { computed, onMounted, onUnmounted, ref } from 'vue'

/** 与 Ant Design Vue 栅格断点一致 */
export const BREAKPOINTS = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600,
} as const

export type BreakpointKey = keyof typeof BREAKPOINTS

/**
 * 监听视口宽度，用于布局响应式（侧栏抽屉、内容区内边距等）。
 */
export function useBreakpoint() {
  const width = ref(getWidth())

  function getWidth() {
    return typeof window !== 'undefined' ? window.innerWidth : BREAKPOINTS.xl
  }

  function onResize() {
    width.value = getWidth()
  }

  onMounted(() => {
    onResize()
    window.addEventListener('resize', onResize, { passive: true })
  })

  onUnmounted(() => {
    window.removeEventListener('resize', onResize)
  })

  const isXs = computed(() => width.value < BREAKPOINTS.sm)
  const isMobile = computed(() => width.value < BREAKPOINTS.md)
  const isTablet = computed(() => width.value >= BREAKPOINTS.md && width.value < BREAKPOINTS.lg)
  const isDesktop = computed(() => width.value >= BREAKPOINTS.lg)

  function below(key: BreakpointKey) {
    return computed(() => width.value < BREAKPOINTS[key])
  }

  function above(key: BreakpointKey) {
    return computed(() => width.value >= BREAKPOINTS[key])
  }

  return {
    width,
    isXs,
    isMobile,
    isTablet,
    isDesktop,
    below,
    above,
  }
}
